import { Form } from 'antd';
import styles from './searchGroup.less?modules';
// import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import ButtonML from '@/components/button_ml/ButtonML';
import SelectML from '@/components/select_ml/SelectML';
import { toOption } from '@/utils/comUtil.js';
import { approvalStatusWithoutApproval } from '@/constants.js';
import { useDispatch, useSelector } from 'dva';
import { useEffect, useCallback, useState } from 'react';

const SearchGroup = () => {
  const [form] = Form.useForm();
  const [diagramNameOption, setDiagramNameOption] = useState({});
  const [versionList, setVersionList] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const bizData = useSelector((state) => state.dvm.approvalList);
  const dispatch = useDispatch();
  const onFinish = (values) => {
    for (let key in values) {
      if (!values[key]) {
        values[key] = undefined;
      }
    }
    dispatch({
      type: 'dr/setSearchValue',
      payload: {
        values,
      },
    });
  };
  const getApprovalList = useCallback(() => {
    dispatch({
      type: 'dvm/getApprovalList',
    });
  }, [dispatch]);
  useEffect(() => {
    getApprovalList();
  }, [getApprovalList]);
  useEffect(() => {
    if (!bizData) {
      return;
    }
    let obj = {};
    bizData &&
      bizData.length > 0 &&
      bizData.map((item) => (obj[item.diagramName] = item.diagramName));
    setDiagramNameOption(obj);
  }, [bizData]);

  // 重置版本号
  const resetFiledVersion = () => {
    let fileValues = form.getFieldValue();
    fileValues.version = undefined;
    form.setFieldsValue({
      ...fileValues,
    });
  };
  const selectDecision = (e) => {
    resetFiledVersion();
    if (e) {
      dispatch({
        type: 'dvm/getVersion',
        payload: {
          values: {
            diagramName: e,
          },
        },
        callback: (res) => {
          let result = [];
          res &&
            res.forEach((item) => {
              result.push({ value: item, name: item });
            });
          setVersionList(result);
          setDisabled(false);
        },
      });
    } else {
      setDisabled(true);
    }
  };

  const reset = () => {
    setDisabled(true);
    form.resetFields();
  };

  return (
    <Form
      form={form}
      name="control-hooks"
      onFinish={onFinish}
      className={styles.serarchFrom}
    >
      {/* 版本号 */}
      <div className={styles.input_contain}>
        <SelectML
          height="37px"
          inputWidth="210px"
          maxWidth="210px"
          labelwidth="130px"
          labelVal="决策图名称"
          placeVal="请选择决策图名称"
          name="diagramName"
          allowClear={true}
          option={toOption(diagramNameOption, true)}
          onChange={selectDecision}
        />
        <SelectML
          height="37px"
          labelwidth="130px"
          inputWidth="210px"
          labelVal="版本号"
          placeVal="请输入版本号"
          name="version"
          allowClear={true}
          disabled={disabled}
          option={versionList}
        />

        {/* 审批状态 */}
        <SelectML
          height="37px"
          labelwidth="130px"
          inputWidth="210px"
          labelVal="审批状态"
          placeVal="请选择审批状态"
          name="approvalStatus"
          allowClear={true}
          option={toOption(approvalStatusWithoutApproval)}
          // icon={}
        />
      </div>

      <div className={styles.btn_contain}>
        <ButtonML size="large" value="查询" htmlType="submit" fontsize="16px" />
        <ButtonML size="large" value="重置" onClick={reset} fontsize="16px" />
      </div>
    </Form>
  );
};

export default SearchGroup;
